import { render, staticRenderFns } from "./NsToolTipBox.vue?vue&type=template&id=025fc407&scoped=true&"
import script from "./NsToolTipBox.vue?vue&type=script&lang=js&"
export * from "./NsToolTipBox.vue?vue&type=script&lang=js&"
import style0 from "./NsToolTipBox.vue?vue&type=style&index=0&id=025fc407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025fc407",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsTooltip: require('/usr/app/src/components/ns/NsTooltip.vue').default})
